const HelpText = () => {
  return (
    <div className='flex flex-col gap-4'>
      <p>This area groups your reporting into focused sections so trends are easier to review.</p>
      <p>Each section uses live pass data for the currently selected client, and most views let you switch between all templates and a single template.</p>
      <p>Use the overview page to choose the type of chart data you want to inspect, then adjust the reporting period inside that section.</p>
    </div>
  )
}

export default HelpText
